(() => {
  'use strict';
  const dataElement = document.getElementById('vd-viewer-data');
  if (!dataElement) return;
  let data;
  try { data = JSON.parse(dataElement.textContent); } catch (_) { return; }
  if (!data.images.length) return;
  const labels = data.labels;
  const icon = (path) => `<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${path}</svg>`;
  const plus = icon('<path d="M12 5v14M5 12h14"/>');
  const minus = icon('<path d="M5 12h14"/>');
  const close = icon('<path d="m6 6 12 12M18 6 6 18"/>');
  const expand = icon('<path d="M8 3H3v5M16 3h5v5M3 16v5h5M21 16v5h-5"/>');
  const key = (url) => {
    try { return new URL(url.trim(), location.href).pathname.replace(/_(?:\d+x\d*|\d*x\d+|small|medium|large|grande|master)(?=\.[^.]+$)/, ''); }
    catch (_) { return url; }
  };
  const indexFor = (link) => data.images.findIndex(item => key(item.src) === key(link.getAttribute('href') || link.querySelector('img')?.src || ''));
  let active = null;
  let pointerStart = null;
  let draggedAt = 0;
  const setupLinks = () => {
    document.querySelectorAll('.product-single__photos .my-gallery a.photoswipe').forEach(link => {
      const index = indexFor(link);
      if (index < 0) return;
      const item = data.images[index];
      link.href = item.src;
      link.dataset.size = `${item.w}x${item.h}`;
      link.setAttribute('aria-haspopup', 'dialog');
      link.setAttribute('aria-label', `${labels.open}: ${item.alt || labels.photo}`);
    });
    document.querySelectorAll('.product-single__photos .block__lager').forEach(root => {
      if (root.querySelector('.vd-gallery-open')) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'vd-gallery-open';
      button.innerHTML = expand + '<span></span>';
      button.querySelector('span').textContent = labels.open;
      button.setAttribute('aria-haspopup', 'dialog');
      button.addEventListener('click', () => {
        const current = root.querySelector('.slick-current a.photoswipe') || root.querySelector('a.photoswipe');
        if (current) open(indexFor(current), button, root.closest('.product-single__photos'));
      });
      root.append(button);
      const sync = () => {
        const slide = root.querySelector('.slick-current');
        button.hidden = !!slide && !slide.querySelector('a.photoswipe');
      };
      if (window.jQuery) window.jQuery(root).find('.slider-for').on('init.vdViewer afterChange.vdViewer', sync);
      sync();
    });
  };
  const open = (index, opener, photosRoot) => {
    if (index < 0 || active || typeof window.PhotoSwipe !== 'function' || typeof window.PhotoSwipeUI_Default !== 'function') return;
    const element = document.createElement('div');
    element.className = 'pswp vd-viewer';
    element.tabIndex = -1;
    element.setAttribute('role', 'dialog');
    element.setAttribute('aria-modal', 'true');
    element.setAttribute('aria-label', labels.viewer);
    element.innerHTML = `<div class="pswp__bg"></div><div class="pswp__scroll-wrap"><div class="pswp__container"><div class="pswp__item"></div><div class="pswp__item"></div><div class="pswp__item"></div></div><div class="pswp__ui"><div class="pswp__top-bar"><div class="pswp__counter" aria-live="polite" aria-atomic="true"></div><div class="vd-viewer__zoom"><button type="button" class="vd-viewer__action" data-action="out">${minus}</button><output class="vd-viewer__scale">100%</output><button type="button" class="vd-viewer__action" data-action="in">${plus}</button><button type="button" class="vd-viewer__fit" data-action="fit"></button></div><button type="button" class="pswp__button pswp__button--close">${close}</button><div class="pswp__preloader"><div class="pswp__preloader__icn"><div class="pswp__preloader__cut"><div class="pswp__preloader__donut"></div></div></div></div></div><button type="button" class="pswp__button pswp__button--arrow--left">${icon('<path d="m14 6-6 6 6 6"/>')}</button><button type="button" class="pswp__button pswp__button--arrow--right">${icon('<path d="m10 6 6 6-6 6"/>')}</button><div class="vd-viewer__footer"><div class="vd-viewer__thumbs"></div><p class="vd-viewer__hint"></p></div></div></div>`;
    const labelButton = (selector, text) => {
      const button = element.querySelector(selector);
      button.setAttribute('aria-label', text);
      button.title = text;
    };
    labelButton('[data-action="out"]', labels.out);
    labelButton('[data-action="in"]', labels.in);
    labelButton('[data-action="fit"]', labels.fit);
    labelButton('.pswp__button--close', labels.close);
    labelButton('.pswp__button--arrow--left', labels.previous);
    labelButton('.pswp__button--arrow--right', labels.next);
    element.querySelector('[data-action="fit"]').textContent = labels.fit;
    element.querySelector('.vd-viewer__hint').textContent = matchMedia('(pointer:coarse)').matches ? labels.touchHint : labels.mouseHint;
    const thumbs = element.querySelector('.vd-viewer__thumbs');
    data.images.forEach((item, i) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'vd-viewer__thumb';
      button.setAttribute('aria-label', `${labels.photo} ${i + 1}`);
      const image = document.createElement('img');
      image.src = item.thumb;
      image.alt = '';
      image.width = 56;
      image.height = 56;
      image.loading = 'lazy';
      button.append(image);
      button.addEventListener('click', () => active?.goTo(i));
      thumbs.append(button);
    });
    document.body.append(element);
    const reduceMotion = matchMedia('(prefers-reduced-motion:reduce)').matches;
    const gallery = new window.PhotoSwipe(element, window.PhotoSwipeUI_Default, data.images.map(item => ({...item})), {
      index, history: false, bgOpacity: 1, mainClass: 'vd-viewer',
      showAnimationDuration: reduceMotion ? 0 : 180,
      hideAnimationDuration: reduceMotion ? 0 : 180,
      showHideOpacity: true, maxSpreadZoom: 2,
      allowPanToNext: false, pinchToClose: false, closeOnVerticalDrag: false, closeOnScroll: false,
      tapToClose: false, tapToToggleControls: false, clickToCloseNonZoomable: false,
      timeToIdle: 0, timeToIdleOutside: 0, closeElClasses: [],
      shareEl: false, fullscreenEl: false, zoomEl: false, captionEl: false,
      barsSize: {top: 76, bottom: 128},
      isClickableElement: el => /^(A|BUTTON|OUTPUT)$/.test(el.tagName),
      getDoubleTapZoom: (_mouse, item) => Math.min(item.initialZoomLevel * 2.5, 2)
    });
    active = gallery;
    const scale = element.querySelector('.vd-viewer__scale');
    const maxZoom = () => Math.max(gallery.currItem.initialZoomLevel, Math.min(2, gallery.currItem.initialZoomLevel * 6));
    let timer;
    let frame;
    let lastRatio;
    const zoomOutButton = element.querySelector('[data-action="out"]');
    const zoomInButton = element.querySelector('[data-action="in"]');
    const update = () => {
      if (active !== gallery || !gallery.currItem) return;
      gallery.options.maxSpreadZoom = maxZoom();
      const ratio = gallery.getZoomLevel() / gallery.currItem.initialZoomLevel;
      const percent = Math.round(ratio * 100);
      if (percent !== lastRatio) {
        scale.textContent = `${percent}%`;
        zoomOutButton.disabled = ratio < 1.01;
        zoomInButton.disabled = gallery.getZoomLevel() > maxZoom() - 0.001;
        lastRatio = percent;
      }
    };
    const delayedUpdate = () => { clearTimeout(timer); timer = setTimeout(update, 220); };
    const changeZoom = (zoom, point, duration = 150) => {
      const minimum = gallery.currItem.initialZoomLevel;
      gallery.zoomTo(Math.min(maxZoom(), Math.max(minimum, zoom)), point || {x: gallery.viewportSize.x / 2, y: gallery.viewportSize.y / 2}, reduceMotion ? 0 : duration);
      delayedUpdate();
    };
    element.querySelector('[data-action="in"]').addEventListener('click', () => changeZoom(gallery.getZoomLevel() * 1.4));
    element.querySelector('[data-action="out"]').addEventListener('click', () => changeZoom(gallery.getZoomLevel() / 1.4));
    element.querySelector('[data-action="fit"]').addEventListener('click', () => changeZoom(gallery.currItem.initialZoomLevel));
    const wheel = event => {
      if (event.target.closest('.vd-viewer__footer,.pswp__top-bar')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const delta = event.deltaY * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? innerHeight : 1);
      changeZoom(gallery.getZoomLevel() * Math.exp(-Math.max(-120, Math.min(120, delta)) * 0.002), {x:event.clientX, y:event.clientY}, 0);
      update();
    };
    element.addEventListener('wheel', wheel, {passive:false, capture:true});
    element.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const focusables = [...element.querySelectorAll('button:not(:disabled)')].filter(button => button.getClientRects().length);
      const first = focusables[0], last = focusables[focusables.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === element)) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || document.activeElement === element)) { event.preventDefault(); first?.focus(); }
    });
    const syncSlide = () => {
      const current = gallery.getCurrentIndex();
      [...thumbs.children].forEach((button, i) => button.setAttribute('aria-current', String(i === current)));
      thumbs.children[current]?.scrollIntoView({block:'nearest', inline:'nearest'});
      const link = [...photosRoot.querySelectorAll('.my-gallery a.photoswipe')].find(a => indexFor(a) === current && !a.closest('.slick-cloned'));
      const slide = link?.closest('[data-slick-index]');
      const slider = photosRoot.querySelector('.slider-for.slick-initialized');
      if (slider && slide && window.jQuery) window.jQuery(slider).slick('slickGoTo', Number(slide.dataset.slickIndex), true);
      update();
    };
    gallery.listen('afterChange', syncSlide);
    gallery.listen('doubleTap', delayedUpdate);
    gallery.listen('zoomGestureEnded', delayedUpdate);
    gallery.listen('resize', delayedUpdate);
    gallery.listen('initialZoomInEnd', delayedUpdate);
    let pushed = false;
    let closedByBack = false;
    const token = Date.now();
    const onBack = () => { closedByBack = true; gallery.close(); };
    gallery.listen('destroy', () => {
      clearTimeout(timer);
      cancelAnimationFrame(frame);
      active = null;
      document.documentElement.classList.remove('vd-viewer-open');
      window.removeEventListener('popstate', onBack);
      element.removeEventListener('wheel', wheel, true);
      element.remove();
      opener?.focus({preventScroll:true});
      if (pushed && !closedByBack && history.state?.vdViewer === token) history.back();
    });
    document.documentElement.classList.add('vd-viewer-open');
    gallery.init();
    syncSlide();
    const tick = () => { if (active !== gallery) return; update(); frame = requestAnimationFrame(tick); };
    frame = requestAnimationFrame(tick);
    try { history.pushState({...history.state, vdViewer:token}, '', location.href); pushed = true; window.addEventListener('popstate', onBack); } catch (_) {}
  };
  document.addEventListener('pointerdown', event => {
    if (!event.target.closest('.product-single__photos .my-gallery')) return;
    pointerStart = {x:event.clientX, y:event.clientY};
  }, true);
  document.addEventListener('pointerup', event => {
    if (pointerStart && Math.hypot(event.clientX - pointerStart.x, event.clientY - pointerStart.y) > 14) draggedAt = Date.now();
    pointerStart = null;
  }, true);
  document.addEventListener('click', event => {
    const link = event.target.closest('.product-single__photos .my-gallery a.photoswipe');
    if (!link || typeof window.PhotoSwipe !== 'function') return;
    const index = indexFor(link);
    if (index < 0) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (Date.now() - draggedAt < 400) return;
    open(index, link, link.closest('.product-single__photos'));
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupLinks);
  else setupLinks();
  document.addEventListener('shopify:section:load', setupLinks);
})();
